/*
 * Copyright (c) 2025 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable } from '@angular/core';
import { OAuthService, OAuthSuccessEvent } from 'angular-oauth2-oidc';

@Injectable()
export class ExtendedOAuthService extends OAuthService {
  /**
   * Stores an externally-provided token (e.g. from query-param authentication)
   * through the library's own storage logic and emits a `token_received` event
   * so that OidcService.syncTokensToLegacyStorage() is triggered automatically.
   */
  storeExternalToken(
    accessToken: string,
    expiresIn: number,
    grantedScopes: string,
    refreshToken: string | null = null
  ): void {
    this.storeAccessTokenResponse(accessToken, refreshToken ?? '', expiresIn, grantedScopes);
    this.eventsSubject.next(new OAuthSuccessEvent('token_received'));
  }
}
